<script>
	import { fade } from "svelte/transition";
	import data from './data';

	const parts = data.map(item => ({
		name: item[0],
		top: item[1],
		left: item[2],
		points: item[3],
		pain: 0,
	}))

	const handleSelectPart = (i) => {
		const selectedPart = parts[i];
		const currentPain = selectedPart.pain;

		if (currentPain === 10) {
			parts[i].isActive = false;
			parts[i].pain = 0;

			return;
		}

		parts[i].isActive = true;
		parts[i].pain = currentPain + 1;
	};

	const handleMouseEnter = (i) => {
		const selectedPart = parts[i];

		if (selectedPart.isActive) {
			return;
		}

		parts[i].isActive = true;
	};

	const handleMouseLeave = (i) => {
		const selectedPart = parts[i];

		if (selectedPart.pain > 0) {
			return;
		}

		parts[i].isActive = false;
	};
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 767.328 621.531"
	width="100%"
	height="100%"
>
	<defs>
		<clipPath id="parts">
			{#each parts as part}
				{#if part.isActive}
					<polygon points={part.points} />
				{/if}
			{/each}
			<polygon />
		</clipPath>
	</defs>
	<image href="images/bodies.png" width="100%" height="100%" />
	<image
		href="images/bodies-highlighted.png"
		width="100%"
		height="100%"
		clip-path="url(#parts)"
	/>
	{#each parts as part, i}
		<g
			class="part"
			on:click={() => handleSelectPart(i)}
			on:mouseenter={() => handleMouseEnter(i)}
			on:mouseleave={() => handleMouseLeave(i)}
		>
			<polygon points={part.points} />
			{#if part.isActive}
				<g
					transform={`translate(${part.left}, ${part.top})`}
					transition:fade={{ duration: 100 }}
				>
					<circle r="10" />
					<text text-anchor="middle" dominant-baseline="middle"
						>{part.pain}</text
					>
				</g>
			{/if}
		</g>
	{/each}
</svg>

<style>
	.part {
		cursor: pointer;
	}

	.part polygon {
		fill: transparent;
	}

	.part circle {
		fill: #2196f3;
		stroke: #ffffff;
		stroke-width: 1;
		pointer-events: none;
	}

	.part text {
		fill: #ffffff;
		font-size: 0.625rem;
		font-weight: 600;
		user-select: none;
	}
</style>
